import { ISubtitles, ICue } from 'src/interfaces/PlayerData';
import ApplicationService from '../ApplicationService';

class SubtitleService {
  get textTracks() {
    return ApplicationService.player?.textTracks;
  }

  get hasSubtitles() {
    return Boolean(this.subtitles && this.subtitles.length > 0);
  }

  get subtitles() {
    const tracks: TextTrack[] = [];

    if (!this.textTracks) return tracks;

    for (let i = 0; i < this.textTracks.length; i++) {
      if (this.textTracks[i].kind === 'subtitles') {
        tracks.push(this.textTracks[i]);
      }
    }

    return tracks;
  }

  get subtitlesOptions() {
    if (!this.hasSubtitles) return;

    const tracks = this.subtitles;
    const formated = this.formatSubtitles(tracks);
    const sort = this.sortSubtitles(formated);

    return sort;
  }

  get activeTrack() {
    const tracks = this.subtitles;
    return tracks.find((track) => track.mode === 'showing');
  }

  get currentCueText() {
    const activeCues = this.activeTrack?.activeCues || [];
    return activeCues.length > 0 ? activeCues[0].text : null;
  }

  formatSubtitles(textTracks: TextTrack[]): ISubtitles[] {
    const subtitles: ISubtitles[] = textTracks.map((track) => ({
      label: track.label,
      language: track.language,
      kind: 'subtitles',
    }));

    return subtitles;
  }

  sortSubtitles(subtitles: ISubtitles[]) {
    return subtitles.length && subtitles.sort((a, b) => a.label.localeCompare(b.label, 'en'));
  }

  disableSubtitle = () => {
    this.setActiveSubtitle(null);
    return ApplicationService.player?.activateSubtitle(false);
  };

  hasSubtitleOfLanguage(language: string) {
    return this.subtitles.some(
      (subtitle) => this.normalizeSubtitle(subtitle.language) === this.normalizeSubtitle(language),
    );
  }

  normalizeSubtitle(language: string) {
    return language.substring(0, 2).toUpperCase();
  }

  setActiveSubtitle(selectedSubtitle: string | null) {
    if (!this.hasSubtitles) return;

    if (selectedSubtitle && !this.hasSubtitleOfLanguage(selectedSubtitle)) return;

    this.subtitles.map((track) => {
      const selected = selectedSubtitle && this.normalizeSubtitle(selectedSubtitle);
      const isActive = this.normalizeSubtitle(track.language) === selected;

      track.mode = isActive ? 'showing' : 'disabled';
    });

    if (!selectedSubtitle) return;
    ApplicationService.player?.activateSubtitle(true);
  }

  addCue(newCue: ICue) {
    newCue.text = newCue.content;

    const track = this.activeTrack;
    track?.addCue?.(newCue);
  }

  removeCue(oldCue: ICue) {
    const track = this.activeTrack;
    oldCue.text = oldCue.content;

    const currentCue = track?.activeCues?.[0];
    if (currentCue?.text === oldCue.text) {
      track?.removeCue?.(currentCue);
    }
  }
}

export default new SubtitleService();
